import { getCookie, setCookie } from "../core/utils.js";

export function form() {
    var url_string = window.location.href;
    var url = new URL(url_string);

    var us = getCookie("utm_source");
    if (us) {
        var f_us = document.querySelector('input[name="utm_source"]');
        var f_us2 = document.querySelector('input[id="utm_source2');
        if (f_us) {
            f_us.value = us;
        }
        if (f_us2) {
            f_us2.value = us;
        }
    }

    var um = getCookie("utm_medium");
    if (um) {
        var f_um = document.querySelector('input[name="utm_medium"]');
        var f_um2 = document.querySelector('input[id="utm_medium2"]');
        if (f_um) {
            f_um.value = um;
        }
        if (f_um2) {
            f_um2.value = um;
        }
    }

    /* var uc = getCookie('utm_campaign');
  if(uc) {
    var f_uc = document.querySelector('input[name="utm_campaign"]');
    if(f_uc) {
      f_uc.value = uc;
    }
  } */

    var gclid = getCookie("gclid");
    if (gclid) {
        var f_gclid = document.querySelector('input[id="gclid"]');
        var f_gclid2 = document.querySelector('input[id="gclid2"]');
        if (f_gclid) {
            f_gclid.value = gclid;
        }
        if (f_gclid2) {
            f_gclid2.value = gclid;
        }

        var f_gad = document.querySelector('input[name="zc_gad"]');
        var f_gad2 = document.querySelector('input[id="zc_gad2"]');
        if (f_gad) {
            f_gad.value = gclid;
        }
        if (f_gad2) {
            f_gad2.value = gclid;
        }
    }

    var gaid = getCookie("_ga");
    if (gaid) {
        var f_gaid = document.querySelector('input[id="gaid"]');
        var f_gaid2 = document.querySelector('input[id="gaid2"]');
        if (f_gaid) {
            f_gaid.value = gaid.slice(6);
        }
        if (f_gaid2) {
            f_gaid2.value = gaid.slice(6);
        }
    }

    if (url.searchParams.get("data")) {
        if (enc_data) {
            var arrData = decodeURIComponent(enc_data);
            if (arrData != "" || arrData != null || arrData != undefined) {
                var arr = JSON.parse(arrData);
                if (arr) {
                    $('input[id="email"]').val(arr["email"]);
                    $('input[id="phone"]').val(arr["phone"]);

                    if (arr["name"]) {
                        $('input[id="full_name"]').val(arr["name"]);
                    }

                    if (arr["full_name"]) {
                        $('input[id="full_name"]').val(arr["full_name"]);
                    }

                    if (arr["cid"]) {
                        $('input[id="cid"]').val(arr["cid"]);
                    }

                    if (arr["company_id"]) {
                        $('input[id="cid"]').val(arr["company_id"]);
                    }

                    if (arr["company"]) {
                        $('input[id="company"]').val(arr["company"]);
                    }

                    if (arr["company_name"]) {
                        $('input[id="company"]').val(arr["company_name"]);
                    }

                    if (arr["user_id"]) {
                        $('input[id="user_id"]').val(arr["user_id"]);
                    }

                    if (arr["user_role"]) {
                        $('input[id="user_role"]').val(arr["user_role"]);
                    }

                    if (arr["job_position"]) {
                        $('input[id="job_position"]').val(arr["job_position"]);
                    }

                    if (arr["number_employees"]) {
                        var $select = $('select[id="employees"]'),
                            $option = $select.find("option");

                        if (arr["number_employees"] <= 50) {
                            $select.find('option[value="1-50"]').attr("selected", "selected");
                            $select.find('option[value="Micro <=50"]').attr("selected", "selected");
                        } else if (arr["number_employees"] > 50 && arr["number_employees"] < 100) {
                            $select.find('option[value="51-100"]').attr("selected", "selected");
                            $select.find('option[value="Small 51-100"]').attr("selected", "selected");
                        } else if (arr["number_employees"] > 100 && arr["number_employees"] < 300) {
                            $select.find('option[value="101-300"]').attr("selected", "selected");
                            $select.find('option[value="Medium 101-300"]').attr("selected", "selected");
                        } else if (arr["number_employees"] > 300 && arr["number_employees"] < 700) {
                            $select.find('option[value="301-700"]').attr("selected", "selected");
                            $select.find('option[value="Large 301-700"]').attr("selected", "selected");
                        } else if (arr["number_employees"] > 700) {
                            $select.find('option[value=">700"]').attr("selected", "selected");
                            $select.find('option[value="Enterprise >700"]').attr("selected", "selected");
                        } else if (arr["number_employees"] == "Micro") {
                            $select.find('option[value="1-50"]').attr("selected", "selected");
                            $select.find('option[value="Micro <=50"]').attr("selected", "selected");
                        } else if (arr["number_employees"] == "Small") {
                            $select.find('option[value="51-100"]').attr("selected", "selected");
                            $select.find('option[value="Small 51-100"]').attr("selected", "selected");
                        } else if (arr["number_employees"] == "Medium") {
                            $select.find('option[value="101-300"]').attr("selected", "selected");
                            $select.find('option[value="Medium 101-300"]').attr("selected", "selected");
                        } else if (arr["number_employees"] == "Large") {
                            $select.find('option[value="301-700"]').attr("selected", "selected");
                            $select.find('option[value="Large 301-700"]').attr("selected", "selected");
                        } else if (arr["number_employees"] == "Enterprise") {
                            $select.find('option[value=">700"]').attr("selected", "selected");
                            $select.find('option[value="Enterprise >700"]').attr("selected", "selected");
                        }

                        $select.selectpicker("refresh");
                    }

                    if (arr["oldemail"]) {
                        $('input[id="oldemail"]').val(arr["oldemail"]);
                    }

                    if (arr["DealName"]) {
                        $('input[id="full_name"]').val(arr["DealName"]);
                    }

                    if (arr["Demo_Company_Id"]) {
                        $('input[id="democompanyid"]').val(arr["democompanyid"]);
                    }
                }
                //$('#data').removeAttr('value');
            }
        }
    }
    var text_truncate = function (str, length, ending) {
        if (length == null) {
            length = 100;
        }
        if (ending == null) {
            ending = "...";
        }
        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    };
    var referrercode = url.searchParams.get("referrer_code") || "";
    var ref = url.searchParams.get("ref") || "";
    var referral_code = url.searchParams.get("referral_code") || "";
    var via = url.searchParams.get("via") || "";
    var usource = url.searchParams.get("utm_source") || "";
    var umedium = url.searchParams.get("utm_medium") || "";
    var ucampaign = url.searchParams.get("utm_campaign") || "";
    var gclid_ = url.searchParams.get("gclid") || getCookie("gclid") || "";
    var msclkid_ = url.searchParams.get("msclkid") || getCookie("msclkid") || "";
    var gclidmsclkid = text_truncate(gclid_ + "|" + msclkid_, 250, "");
    var cid = url.searchParams.get("CID") || "";
    var cid2 = url.searchParams.get("cid") || "";
    var name = url.searchParams.get("Name") || "";
    var dealname = url.searchParams.get("DealName") || "";
    var email = url.searchParams.get("Email") || "";
    var oldemail = url.searchParams.get("oldemail") || "";
    var phone = url.searchParams.get("Phone") || "";
    var company = url.searchParams.get("Company") || "";
    var stage = url.searchParams.get("stage") || "";
    var city = url.searchParams.get("city") || "";
    var industry = url.searchParams.get("industry") || "";
    var democompanyid = url.searchParams.get("Demo_Company_Id") || "";
    var employee_name = url.searchParams.get("employee_name") || "";
    var employee_email = url.searchParams.get("employee_email") || "";
    var company_name = url.searchParams.get("company_name") || "";
    var employee_id = url.searchParams.get("employee_id") || "";
    var employee_num = url.searchParams.get("Employee") || "";
    var job = url.searchParams.get("job") || "";
    var lead_source_detail = url.searchParams.get("lead_source_detail") || "";
    var devicetype = "desktop";
    var matchtype = url.searchParams.get("matchtype") || getCookie("matchtype") || "";
    var uterm = url.searchParams.get("utm_term") || getCookie("utm_term") || "";
    var banner_click = getCookie("devicetype") || "";

    if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
            navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            navigator.userAgent.substr(0, 4)
        )
    ) {
        devicetype = "mobile";
    } else {
        devicetype = "desktop";
    }

    if (devicetype) {
        var f_devicetype = document.querySelector('input[id="device"]');
        var f_devicetype2 = document.querySelector('input[id="device2"]');
        if (f_devicetype) {
            f_devicetype.value = devicetype;
        }
        if (f_devicetype2) {
            f_devicetype2.value = devicetype;
        }
    }

    if (referrercode) {
        var f_referrer = document.querySelector('input[id="referrer_code"]');
        if (f_referrer) {
            f_referrer.value = referrercode;
        }

        var h_referrer = document.querySelector('input[name="referrer_code"]');
        if (h_referrer) {
            h_referrer.value = referrercode;
        }
    }

    if (ref) {
        var f_ref = document.querySelector('input[id="ref"]');
        if (f_ref) {
            f_ref.value = ref;
        }
    }

    if (referral_code) {
        var f_referral_code = document.querySelector('input[id="referral_code"]');
        if (f_referral_code) {
            f_referral_code.value = referral_code;
        }
    }

    if (via) {
        var f_via = document.querySelector('input[id="via"]');
        if (f_via) {
            f_via.value = via;
        }

        var f_via = document.querySelector('input[name="via"]');
        if (f_via) {
            f_via.value = via;
        }
    }

    if (usource) {
        var f_us = document.querySelectorAll('input[name="utm_source"]');
        var f_us2 = document.querySelector('input[id="utm_source2"]');
        if (f_us) {
            for (var i = 0; i < f_us.length; i++) {
                f_us[i].value = usource;
            }
        }
        if (f_us2) {
            f_us2.value = usource;
        }
    }

    if (uterm != "" && matchtype != "") {
        var term = "";
        term = " @ " + matchtype + "|" + uterm;
    } else if (getCookie("termmatchtype")) {
        var term = "";
        term = getCookie("termmatchtype");
    } else {
        var term = "";
        if (getCookie("utm_term") && getCookie("matchtype")) {
            term = " @ " + getCookie("matchtype") + "|" + getCookie("utm_term");
            setCookie("termmatchtype", term, 2);
        }
    }

    if (ucampaign) {
        var f_uc = document.querySelectorAll('input[name="utm_campaign"]');
        var f_uc2 = document.querySelector('input[id="utm_campaign2"]');
        var j = getCookie("user_journey");
        if (j) {
            var jour = text_truncate(j, 245);
            if (f_uc) {
                for (var i = 0; i < f_uc.length; i++) {
                    f_uc[i].value = jour + banner_click;
                }
            }
            if (f_uc2) {
                f_uc2.value = jour + banner_click;
            }
        } else {
            if (f_uc) {
                f_uc.value = jour + banner_click;
            }
            if (f_uc2) {
                f_uc2.value = jour + banner_click;
            }
        }
    } else {
        var uc = getCookie("utm_campaign");
        if (uc) {
            var f_uc = document.querySelectorAll('input[name="utm_campaign"]');
            var f_uc2 = document.querySelector('input[id="utm_campaign2"]');
            var j = getCookie("user_journey");
            if (j) {
                var jour = text_truncate(j, 245);
                if (f_uc) {
                    for (var i = 0; i < f_uc.length; i++) {
                        f_uc[i].value = jour + banner_click;
                    }
                }
                if (f_uc2) {
                    f_uc2.value = jour + banner_click;
                }
            } else {
                if (f_uc) {
                    f_uc.value = jour + banner_click;
                }
                if (f_uc2) {
                    f_uc2.value = jour + banner_click;
                }
            }
        } else {
            var j = getCookie("user_journey");
            if (j) {
                var jour = text_truncate(j, 245);
                var f_uc = document.querySelectorAll('input[name="utm_campaign"]');
                var f_uc2 = document.querySelector('input[id="utm_campaign2"]');
                if (f_uc) {
                    for (var i = 0; i < f_uc.length; i++) {
                        f_uc[i].value = jour + banner_click;
                    }
                }
                if (f_uc2) {
                    f_uc2.value = jour + banner_click;
                }
            }
        }
    }

    if (gclid_) {
        var f_gclid = document.querySelector('input[id="gclid"]');
        var f_gclid2 = document.querySelector('input[id="gclid2"]');
        if (f_gclid) {
            f_gclid.value = gclidmsclkid;
        }
        if (f_gclid2) {
            f_gclid2.value = gclidmsclkid;
        }

        var f_gad = document.querySelector('input[name="zc_gad"]');
        var f_gad2 = document.querySelector('input[id="zc_gad2"]');
        if (f_gad) {
            f_gad.value = gclidmsclkid;
        }
        if (f_gad2) {
            f_gad2.value = gclidmsclkid;
        }
    }

    if (cid) {
        var f_cid = document.querySelector('input[id="cid"]');
        var f_cid2 = document.querySelector('input[id="cid2"]');
        if (f_cid) {
            f_cid.value = cid;
        }
        if (f_cid2) {
            f_cid2.value = cid;
        }
    }

    if (cid2) {
        var f_cid = document.querySelector('input[id="cid"]');
        if (f_cid) {
            f_cid.value = cid2;
        }
    }

    if (name) {
        var f_name = document.querySelector('input[id="full_name"]');
        if (f_name) {
            f_name.value = name;
        }
    }

    if (dealname) {
        var f_name = document.querySelector('input[id="full_name"]');
        if (f_name) {
            f_name.value = dealname;
        }
    }

    if (email) {
        var f_email = document.querySelector('input[id="email"]');
        if (f_email) {
            f_email.value = email;
        }
    }

    if (oldemail) {
        var f_oldemail = document.querySelector('input[id="oldemail"]');
        if (f_oldemail) {
            f_oldemail.value = oldemail;
        }
    }

    if (democompanyid) {
        var f_democompanyid = document.querySelector('input[id="democompanyid"]');
        if (f_democompanyid) {
            f_democompanyid.value = democompanyid;
        }
    }

    if (phone) {
        var f_phone = document.querySelector('input[id="phone"]');
        if (f_phone) {
            f_phone.value = phone;
        }
    }

    if (company) {
        var f_company = document.querySelector('input[id="company"]');
        if (f_company) {
            f_company.value = company;
        }
    }

    if (stage) {
        var f_stage = document.querySelector('input[id="stage"]');
        if (f_stage) {
            f_stage.value = stage;
        }

        var f_stage2 = document.querySelector('input[id="dummy_3"]');
        if (f_stage2) {
            f_stage2.value = stage;
        }
    }

    if (employee_name) {
        var f_employee_name = document.querySelector('input[id="name_em"]');
        if (f_employee_name) {
            f_employee_name.value = employee_name;
        }
    }

    if (employee_email) {
        var f_employee_email = document.querySelector('input[id="email_em"]');
        if (f_employee_email) {
            f_employee_email.value = employee_email;
        }
    }

    if (company_name) {
        var f_company_name = document.querySelector('input[id="company_name"]');
        if (f_company_name) {
            f_company_name.value = company_name;
        }
    }

    if (employee_id) {
        var f_employee_id = document.querySelector('input[id="employee_id"]');
        if (f_employee_id) {
            f_employee_id.value = employee_id;
        }
    }

    if (employee_num) {
        var $select = $('select[id="employees"]'),
            $option = $select.find("option");

        if (employee_num <= 50) {
            $select.find('option[value="1-50"]').attr("selected", "selected");
        } else if (employee_num > 50 && employee_num < 100) {
            $select.find('option[value="51-100"]').attr("selected", "selected");
        } else if (employee_num > 100 && employee_num < 300) {
            $select.find('option[value="101-300"]').attr("selected", "selected");
        } else if (employee_num > 300 && employee_num < 700) {
            $select.find('option[value="301-700"]').attr("selected", "selected");
        } else if (employee_num > 700) {
            $select.find('option[value=">700"]').attr("selected", "selected");
        }
    }

    if (lead_source_detail) {
        var f_lead_source_detail = document.querySelector('input[id="lsd"]');
        if (f_lead_source_detail) {
            f_lead_source_detail.value = lead_source_detail;
        }
    }

    if (job) {
        var f_job = document.querySelector('input[id="job"]');
        if (f_job) {
            f_job.value = job;
        }
    }

    var hc = document.querySelector("#holding_check");
    if (hc) {
        var hc_ = document.querySelector("#holding_comp");
        hc.addEventListener("change", function (e) {
            if (this.checked == true) {
                if (hc_) {
                    hc_.value = "Ya";
                }
            } else {
                if (hc_) {
                    hc_.value = "Tidak";
                }
            }
        });
    }
}
